/*
==================================================
KATIA PICON
COLLECTION PAGE
==================================================
*/

document.addEventListener("DOMContentLoaded", function () {

    const sortSelect = document.getElementById("KPSortBy");

    if (!sortSelect) return;

    sortSelect.addEventListener("change", function () {

        const url = new URL(window.location.href);

        const value = this.value;

        if (value) {

            url.searchParams.set("sort_by", value);

        } else {

            url.searchParams.delete("sort_by");

        }

        window.location.href = url.toString();

    });

});